const ProductData = {
    title: 'Smart Watch 911 - El mas resistente',
    description: 'Pueden usar una conexión celular para la funcionalidad Emergencia SOS. Para usar esta funcionalidad en el 911 Watch sin conexión celular, es necesario que tu cel esté cerca. Si tu cel no está cerca, el 911 Watch debe estar conectado a una red Wi-Fi conocida y tener la funcionalidad de llamadas por Wi-Fi configurada.',

    colorOptions: [
        {
            styleName: 'Black',
            imageUrl:'https://imgur.com/iOeUBV7.png'
        },

        {
            styleName: 'Red',
            imageUrl:'https://imgur.com/PTgQlim.png'
        },

        {
            styleName: 'Blue',
            imageUrl:'https://imgur.com/Mplj1YR.png'
        },

        {
            styleName: 'Purple',
            imageUrl:'https://imgur.com/xSIK4M8.png'
        }


    ],
    featureList: [
        "Time", "Heart Rate"
    ]

}
// Esta linea convierte el codigo en una constante para que los valores no puedan ser modificados
Object.freeze(ProductData); 

export default ProductData;